var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.082 9.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(-4.5 -10.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M20.87,11.548H5.212a.714.714,0,0,1-.712-.712h0a.714.714,0,0,1,.712-.712H20.87a.714.714,0,0,1,.712.712h0A.714.714,0,0,1,20.87,11.548Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M20.87,18.3H5.212a.714.714,0,0,1-.712-.712h0a.714.714,0,0,1,.712-.712H20.87a.714.714,0,0,1,.712.712h0A.714.714,0,0,1,20.87,18.3Z",
    transform: "translate(0 -2.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M20.87,25.048H5.212a.714.714,0,0,1-.712-.712h0a.714.714,0,0,1,.712-.712H20.87a.714.714,0,0,1,.712.712h0A.714.714,0,0,1,20.87,25.048Z",
    transform: "translate(0 -4.959)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawericon);
export default __webpack_public_path__ + "static/media/drawericon.5bb805a2e549fa6369498319a681ff48.svg";
export { ForwardRef as ReactComponent };